/**
 * Tab Switching Component
 */

document.addEventListener('DOMContentLoaded', () => {
  const tabContainers = document.querySelectorAll('[data-tabs]');

  tabContainers.forEach((container) => {
    const tabs = container.querySelectorAll('[data-tab]');
    const panels = container.querySelectorAll('[data-tab-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const target = tab.getAttribute('data-tab');

        // Update active tab
        tabs.forEach((t) => t.classList.remove('is-active'));
        tab.classList.add('is-active');

        // Show target panel
        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
        });
      });
    });
  });
});
